export const css = {
	root: 'BZvZCNLY',
	item: '_1UmJ38c7',
	complete: '_2_i_2_VK',
	readtime: '_1MB5k0bM',
	indented: '_1BDJhyyp',
	leaf: '_3ZT4XlgK',
	leafItem: 'xfWIGttM',
	treeRoot: 'eHDXp2fD',
	treeNode: '_3H7I3gqz',
	contentWrapper: '_3CqFg_6w',
	content: '_2x65cpj4',
	title: '_3VhC_quk',
	expander: '_1Hdu3Rjy',
	video: '_3I-d_zGx',
	' _key': 'ascm-theme/ascm/table-of-contents/toc'
};

export default css;
